module.exports = __webpack_public_path__ + "static/media/TrueNorth_Settings.6b52fdac.png";